export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

type Envelope<T> = { success: true; data: T } | { success: false; error: { message: string } };

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`/api${path}`, {
    credentials: "include",
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...options.headers,
    },
    ...options,
  });

  const payload = (await response.json().catch(() => null)) as Envelope<T> | null;

  if (!response.ok || !payload || payload.success === false) {
    const message =
      payload && "error" in payload
        ? typeof payload.error === "string"
          ? payload.error
          : payload.error.message
        : "Something went wrong. Please try again.";
    throw new ApiError(message, response.status);
  }

  return payload.data;
}
